import { useRef } from "react";
import { t } from "i18next";
import FormDropdown from "../../components/form-dropdown/FormDropdown";
import TechnicianSelect from "../../components/data/technician/TechnicianSelect";
import { Typography } from "@material-tailwind/react";
import ReplenishmentPartsManager from "./components/ReplenishmentPartsManager";
import SimpleSelect from "../../components/data/simple-select/SimpleSelect";

/**
 * Form for creating/editing a replenishment
 */
export default function ReplenishmentForm({
  data,
  onChange,
  onSubmit,
  submitted,
  isEditing,
  disabled = false,
}: {
  data?: Partial<EasyTech.Replenishment>,
  onChange: (name: string, value: any) => void,
  onSubmit: () => void,
  submitted?: boolean,
  isEditing?: boolean,
  disabled?: boolean
}) {
  const changeRef = useRef(onChange);
  changeRef.current = onChange;

  return (
    <>
      <FormDropdown label={t("replenishment:fields.technician") + " *"}>
        <div className="field full-drawer" data-field="technician">
          <TechnicianSelect
            onChange={(value) => {
              onChange("technician", value);
            }}
            value={data?.technician ? data.technician : undefined}
            className="w-full"
            disabled={disabled}
          />
        </div>
      </FormDropdown>


      {/* Display van to be restocked if technician has one */}
      {data?.technician?.van && (
        <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
          <Typography variant="small" className="text-blue-gray-700 font-semibold">
            {t("replenishment:fields.vanToRestock")} :
          </Typography>
          <Typography variant="paragraph" className="text-blue-900 font-bold mt-1">
            {data.technician.van.name}
          </Typography>
        </div>
      )}

      <FormDropdown label={t("replenishment:fields.partsOrdered")}>
        <div className="p-4">
          <ReplenishmentPartsManager
            parts={data?.parts || []}
            onChange={(parts) => onChange("parts", parts)}
            disabled={disabled}
          />
        </div>
      </FormDropdown>

      <FormDropdown label={t("replenishment:fields.priority")}>
        <div className="field full-drawer">
          <SimpleSelect
            value={data?.priority || "NORMAL"}
            isDisabled={disabled}
            options={[
              { value: "NORMAL", label: t("replenishment:priority.NORMAL") },
              { value: "URGENT", label: t("replenishment:priority.URGENT") },
            ]}
            onChange={(value) => onChange("priority", value || "NORMAL")}
          />
        </div>
      </FormDropdown>

      <FormDropdown label={t("common:comments")}>
        <div className="field full-drawer">
          <textarea
            value={data?.comments || ""}
            onChange={(e) => onChange("comments", e.target.value)}
            placeholder={t("common:comments")}
            maxLength={1000}
            className="form-field"
            rows={4}
            disabled={disabled}
          />
          <div className="flex justify-between items-center mt-1">
            <span className="text-xs text-gray-500">
              {t("workorder:infos.notes.help")}
            </span>
            <span className={`text-xs ${(data?.comments?.length || 0) > 1000 ? "text-red-500 font-semibold" : "text-gray-500"}`}>
              {(data?.comments?.length || 0)}/1000
            </span>
          </div>
        </div>
      </FormDropdown>

    </>
  );
}
